function TitleHeading({ children }) {
  return <h3> {children} </h3>;
}
export default TitleHeading;
